export function useSetUserRuntimeEnvDeviceDetails() {
  //   do nothing for web
}
